import styled from 'styled-components'
import media from '../../../styles/media'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const ImgContainer = styled.div`
  display: none;
  ${media.md`
    display: flex;
    padding: 3rem;
  `}
`

export const Img = styled.img`
  max-width: 540px;
  max-height: 360px;
`

export const Card = styled.div`
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
`
